export const CONTENT_MARKER = '[[content]]'

const KEEP_TEXT = /^(font-size|font-weight|font-style|color|line-height|letter-spacing|text-transform|text-align)$/
const KEEP_BOX = /^(background-color|border|border-radius|padding)$/
const KEEP_BUTTON = /^(font-size|font-weight|color|line-height|background-color|padding|border-radius|text-align)$/

export const isButtonWrapper = (wrapper: string): boolean => /<a\s/i.test(wrapper)

const innermostStyle = (wrapper: string): string => {
  const before = wrapper.slice(0, Math.max(0, wrapper.indexOf(CONTENT_MARKER)))
  const tags = Array.from(before.matchAll(/<(p|div|td|a|h[1-6])\b[^>]*\bstyle="([^"]*)"/g))
  return tags.length ? tags[tags.length - 1][2] : ''
}

export const textDeclarations = (css: string): Array<[string, string]> =>
  css
    .split(';')
    .map((declaration): [string, string] => {
      const [property = '', ...value] = declaration.split(':')
      return [property.trim(), value.join(':').trim()]
    })
    .filter(([property, value]) => KEEP_TEXT.test(property) && property !== 'text-align' && value !== '')

export const displayStyleForWrapper = (wrapper: string): string => {
  const button = isButtonWrapper(wrapper)
  const keep = button ? KEEP_BUTTON : KEEP_TEXT
  const declarations = innermostStyle(wrapper)
    .split(';')
    .map((declaration) => declaration.trim())
    .filter((declaration) => keep.test(declaration.split(':')[0]?.trim() ?? ''))
  const withAlignment =
    button && !declarations.some((declaration) => declaration.startsWith('text-align')) ? [...declarations, 'text-align: center'] : declarations
  return withAlignment.join('; ')
}

export const displayStyleForGroupWrapper = (wrapper: string): string =>
  innermostStyle(wrapper)
    .split(';')
    .map((declaration) => declaration.trim())
    .filter((declaration) => {
      const property = declaration.split(':')[0]?.trim() ?? ''
      return KEEP_TEXT.test(property) || KEEP_BOX.test(property)
    })
    .join('; ')
